module.exports = __webpack_public_path__ + "img/text.32de0449.png";